import React from "react";

interface SystemInformationRowProps {
  title: string;
  content: string;
}

export const SystemInformationRow = ({title, content}: SystemInformationRowProps) => (
  <div className="px-4 py-3 flex flex-row justify-between">
    <div className="text-gray-900">
      {title}
    </div>
    <div className="text-gray-400">
      {content}
    </div>
  </div>
)